<template>
    <div class="panel panel-cascade" style="margin-bottom:0">
        <div class="panel-body" style="background-color:#e8f1fb">
            <div class="row">
                <template v-if="!item.customerid">
                    <div class="col-md-4 form-group">
                        <label class="control-label">Customer Name</label>
                        <input v-model="form.customername" type="text" class="form-control form-cascade-control input-small"/>
                    </div>
                    <div class="col-md-4 form-group">
                        <label class="control-label">Mobile</label>
                        <input v-model="form.customermobile" type="text" maxlength="10" inputmode="numeric"
                            class="form-control form-cascade-control input-small"/>
                    </div>
                    <div class="col-md-4 form-group">
                        <label class="control-label">Address</label>
                        <input v-model="form.customeraddress" type="text" class="form-control form-cascade-control input-small"/>
                    </div>
                </template>
                <div class="col-md-4 form-group">
                    <label class="control-label">Sale By</label>
                    <select v-model="form.salebyid" class="form-control form-cascade-control input-small">
                        <option :value="0">---Select---</option>
                        <option v-for="e in saleemployees" :key="e.id" :value="e.id">{{ e.name }}</option>
                    </select>
                </div>
                <div class="col-md-12" style="margin-bottom:6px">
                    <label class="control-label">Product:</label>
                    <strong> {{ item.product?.category?.name }} {{ item.product?.name }}</strong>
                    <button type="button" class="btn btn-link btn-xs" @click="changeproduct = !changeproduct">
                        {{ changeproduct ? 'keep this product' : 'change product' }}
                    </button>
                </div>
                <template v-if="changeproduct">
                    <div class="col-md-3 form-group">
                        <label class="control-label">Category</label>
                        <select v-model="parentid" class="form-control form-cascade-control input-small"
                            @change="category_id = 0; brands = []; brandid = 0; products = []; productid = 0">
                            <option :value="0">---Select---</option>
                            <option v-for="c in parentcategory" :key="c.id" :value="c.id">{{ c.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-3 form-group">
                        <label class="control-label">Product</label>
                        <select v-model="category_id" class="form-control form-cascade-control input-small" @change="fetchbrands()">
                            <option :value="0">---Select---</option>
                            <option v-for="c in subcategory" :key="c.id" :value="c.id">{{ c.name }}</option>
                        </select>
                    </div>
                    <div class="col-md-3 form-group">
                        <label class="control-label">Company</label>
                        <select v-model="brandid" class="form-control form-cascade-control input-small" @change="fetchproducts()">
                            <option :value="0">---Select---</option>
                            <option v-for="b in brands" :key="b.id" :value="b.id">{{ b.value }}</option>
                        </select>
                    </div>
                    <div class="col-md-3 form-group">
                        <label class="control-label">Model Name</label>
                        <select v-model="productid" class="form-control form-cascade-control input-small">
                            <option :value="0">---Select---</option>
                            <option v-for="p in products" :key="p.id" :value="p.id">{{ p.name }}</option>
                        </select>
                    </div>
                </template>
                <div class="col-md-12 form-group">
                    <label class="control-label">Order Remark</label>
                    <input v-model="form.remark" type="text" class="form-control form-cascade-control input-small"/>
                </div>
                <div class="col-md-12 text-right">
                    <button type="button" class="btn btn-success" :disabled="saving" @click="save()">
                        {{ saving ? 'Saving...' : 'Save Order' }}
                    </button>
                    <button type="button" class="btn btn-danger" :disabled="saving" @click="$emit('close')">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
// Edit a pending/approved order from its conversation: product (same
// category > product > company > model picker as New Order), remark, and the
// customer details when the order has no registered customer.
export default {
    props: ['item'],
    data() {
        return {
            saving: false,
            changeproduct: false,
            parentid: 0,
            category_id: 0,
            brandid: 0,
            productid: 0,
            brands: [],
            products: [],
            form: {
                customername: this.item.customername || '',
                customermobile: this.item.customermobile ? String(this.item.customermobile) : '',
                customeraddress: this.item.customeraddress || '',
                remark: this.item.remark || '',
                salebyid: this.item.salebyid || 0
            },
            saleemployees: []
        }
    },
    computed: {
        ...mapGetters(['categories']),
        parentcategory() {
            return (this.categories || []).filter(c => c.parent_id == 0)
        },
        subcategory() {
            return (this.categories || []).filter(c => c.parent_id == this.parentid)
        }
    },
    mounted() {
        if (!this.categories || this.categories.length == 0) {
            this.$store.dispatch('fetchcategorieslite')
        }
        window.axios.post('api/vsdigi/users/fetch', { isemployee: 1, active: 0 })
            .then(response => this.saleemployees = response.data)
            .catch(error => console.log(error));
    },
    methods: {
        fetchbrands() {
            this.brandid = 0
            this.products = []
            this.productid = 0
            window.axios.post('api/attribute/values/fetchbycategory', { parentcategoryid: this.category_id, attributeid: 2 })
                .then(response => { this.brands = response.data })
                .catch(error => console.log(error))
        },
        fetchproducts() {
            this.productid = 0
            window.axios.post('api/products/fetchbyfilters',
                { parentcategoryid: this.category_id, attributeid: 2, attributevalueids: this.brandid })
                .then(response => { this.products = response.data })
                .catch(error => console.log(error))
        },
        save() {
            const param = { id: this.item.id, remark: this.form.remark }
            if (this.form.salebyid > 0) {
                param.salebyid = this.form.salebyid
            }
            if (!this.item.customerid) {
                if (!/^\d{10}$/.test(this.form.customermobile)) {
                    this.$notify({ text: 'Mobile no. must be 10 digits', type: 'error' })
                    return
                }
                param.customername = this.form.customername
                param.customermobile = this.form.customermobile
                param.customeraddress = this.form.customeraddress
            }
            if (this.changeproduct) {
                if (!this.productid) {
                    this.$notify({ text: 'Select the model, or keep the current product', type: 'error' })
                    return
                }
                param.productid = this.productid
            }
            this.saving = true
            this.$http.post('api/vsdigi/leads/orders/edit', param)
                .then(() => {
                    this.$notify({ text: 'Order updated', type: 'success' })
                    this.$emit('saved')
                })
                .catch((err) => {
                    console.log(err)
                    this.$notify({ text: err.response?.data?.message || 'Unable to update the order', type: 'error' })
                })
                .finally(() => {
                    this.saving = false
                })
        }
    }
}
</script>
